export default "__VITE_ASSET__016aff46__"